var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;

  return _c('article', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "article__top"
  }, [_c('time', {
    staticClass: "date",
    attrs: {
      "datetime": _vm.forum.published_at
    }
  }, [_vm._v(" " + _vm._s(_setup.moment(_vm.forum.published_at).format("YYYY年MM月DD日")) + " ")]), _c('p', {
    staticClass: "division"
  }, [_vm._v(_vm._s(_vm.forum.author_name))])]), _c('div', {
    staticClass: "article__bottom"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_vm.forum.target === 'school' ? _c('span', {
    staticClass: "icon school"
  }, [_vm._v("先生")]) : _vm._e(), _vm.forum.target === 'guardian' ? _c('span', {
    staticClass: "icon guardian"
  }, [_vm._v(" 保護者 ")]) : _vm._e(), _vm.forum.is_important ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
      "fill": "#AB001C"
    }
  })]) : _vm._e(), _vm.forum.created_at !== _vm.forum.updated_at ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18"
    }
  }, [_c('path', {
    attrs: {
      "id": "update_FILL0_wght400_GRAD0_opsz48",
      "d": "M129.075-822a8.8,8.8,0,0,1-3.525-.713,9.3,9.3,0,0,1-2.887-1.937,9.048,9.048,0,0,1-1.95-2.875A8.8,8.8,0,0,1,120-831.05a8.619,8.619,0,0,1,.713-3.5,8.978,8.978,0,0,1,1.95-2.837,9.237,9.237,0,0,1,2.887-1.912,8.931,8.931,0,0,1,3.525-.7,8.5,8.5,0,0,1,3.787.875,9.514,9.514,0,0,1,3.088,2.4v-2.65h1.5v5.2h-5.225v-1.5h2.625a8.694,8.694,0,0,0-2.587-2.05,6.8,6.8,0,0,0-3.188-.775,7.447,7.447,0,0,0-5.35,2.137,6.982,6.982,0,0,0-2.225,5.238,7.4,7.4,0,0,0,2.2,5.4,7.271,7.271,0,0,0,5.375,2.225,7.09,7.09,0,0,0,5.275-2.2,7.339,7.339,0,0,0,2.15-5.325H138a8.764,8.764,0,0,1-2.6,6.387A8.548,8.548,0,0,1,129.075-822Zm3.05-4.925-3.85-3.8v-5.35h1.5v4.725L133.2-828Z",
      "transform": "translate(-120 840)",
      "fill": "#464646"
    }
  })]) : _vm._e()]), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'gov.show',
        params: {
          id: _vm.forum.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.forum.title) + " ")]), _vm.forum.attachment_count ? _c('i', {
    staticClass: "fas fa-paperclip"
  }) : _vm._e(), _c('p', {
    staticClass: "excerpt"
  }, [_vm._v(" " + _vm._s(_vm.forum.message) + " ")])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };